import './fullscreen_button_component.scss'
import { inIframe } from 'relation-map/utils'
import { Controller } from 'stimulus'

export default class extends Controller {
  static classes = ['hide']

  connect = (): void => {
    if (!inIframe()) this.hide()
  }

  hide = (): void => {
    this.element.classList.add(this.hideClass)
  }
}
